/* @flow */
import React, { Component } from 'react';
import { DebounceInput } from 'react-debounce-input';

import i18n from '../../../../i18n/i18n.js';

type Props = {
    checkVoucherCode: Function,
    deleteVoucher: Function,
    handleFocus: Function,
    lng: string,
    errorMessage: string,
    discountAmount: number,
    voucherValue: string,
    branding: Object,
    active: boolean,
    hasInputValue: boolean,
};

type State = {
    hover: boolean,
};

export default class PaymentVoucher extends Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            hover: false,
            checked: false,
        };
    }

    toggleHover = () => {
        this.setState({ hover: !this.state.hover });
    };

    toggleCheckbox = () => {
        this.setState({ checked: !this.state.checked });
    };

    render() {
        const {
            lng,
            discountAmount,
            branding,
            errorMessage,
            setupFee,
        } = this.props;

        let hoverColor;
        if (this.state.hover) {
            hoverColor = branding ? branding : '#00aae6';
        }
        let focusColor = '#d7dde5';
        if (this.props.active) {
            focusColor = branding ? branding : '#00aae6';
        }

        /* ICON COLOR */
        let iconColor = '#d7dde5';
        if (this.props.hasInputValue) {
            iconColor = branding ? branding : '#d7dde5';
        }

        if (errorMessage !== '') {
            iconColor = `#f26f59`;
        }

        /* INPUT BORDER COLOR */
        const debounceInputBorder =
            errorMessage !== ''
                ? `1px solid #f26f59`
                : `1px solid ${focusColor}`;

        /* LABEL COLOR */
        const labelColor = errorMessage !== '' ? 'invalid' : '';

        return (
            <div className="voucherholder">
                <input
                    className={
                        'ipx-checkhid ' +
                        (this.props.addInputChecked && 'addvoucherchecked')
                    }
                    type="checkbox"
                    id="addvoucher"
                    onChange={this.props.toggleCheckbox}
                />
                <label
                    className="labelcheck"
                    htmlFor="addvoucher"
                    onClick={this.props.deleteVoucher}
                    onMouseOver={this.toggleHover}
                    onMouseOut={this.toggleHover}
                >
                    <i
                        className="ipic_add"
                        style={{
                            color: hoverColor,
                            transition: 'all ease 450ms',
                        }}
                    />
                    <span
                        style={{
                            color: hoverColor,
                            transition: 'all ease 450ms',
                        }}
                    >
                        {i18n.t('placeholder_voucher', { lng })}
                    </span>
                </label>
                <div className="labelholder">
                    <DebounceInput
                        inputRef={ref => {
                            this.voucherCode = ref;
                        }}
                        id="voucher"
                        placeholder=" "
                        value={this.props.voucherValue}
                        type="text"
                        name="voucher"
                        debounceTimeout={1000}
                        onChange={this.props.checkVoucherCode}
                        onFocus={e => {
                            this.props.handleFocus(e);
                        }}
                        className={labelColor}
                        onBlur={e => {
                            this.props.handleFocus(e);
                        }}
                        style={{ borderBottom: debounceInputBorder }}
                    />
                    <i className="ipic_voucher" style={{ color: iconColor }} />
                    <label htmlFor="voucher">
                        {i18n.t('placeholder_voucher_code', {
                            lng,
                        })}
                    </label>
                </div>
                {discountAmount !== undefined &&
                    discountAmount !== '' && (
                        <p className="discount">
                            Left to pay:
                            <strong>
                                {setupFee
                                    ? setupFee.fee_amount + discountAmount
                                    : discountAmount}
                            </strong>
                        </p>
                    )}
                <span className="validation-error">{errorMessage}</span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/ui/components/Forms/Payments/PaymentVoucher.js